import * as React from "react";
import { Droppable } from "react-beautiful-dnd";
import styled from "styled-components";

interface IProps {
  children: JSX.Element | JSX.Element[];
  category: { id: number | string };
  items: { id: number | string }[];
  header?: string;
  color?: string;
  borderStyle?: string;
  padding?: string;
  margin?: string;
  width?: string;
  height?: string;
  borderRadius?: string;
}

const Container = styled.div`
  border: ${props => props.style.borderStyle || ""};
  background-color: ${props => props.style.color || ""};
  padding: ${props => props.style.padding || ""};
  margin: ${props => props.style.margin || ""};
  width: ${props => props.style.width || ""};
  height: ${props => props.style.height || ""};
  border-radius: ${props => props.style.borderRadius || ""};
`;

const InnerContainer = styled.div`
  width: 100%;
`;

function ContainerDroppable({
  children,
  category,
  color,
  borderStyle,
  padding,
  margin,
  width,
  height,
  borderRadius,
}: IProps) {
  return (
    <Container
      style={{
        borderStyle: borderStyle,
        color: color,
        padding: padding,
        margin: margin,
        width: width,
        height: height,
        borderRadius: borderRadius,
      }}
    >
      <Droppable droppableId={category.id}>
        {provided => (
          <InnerContainer ref={provided.innerRef} {...provided.droppableProps}>
            {children}
            {provided.placeholder}
          </InnerContainer>
        )}
      </Droppable>
    </Container>
  );
}
export default ContainerDroppable;



// WEBPACK FOOTER //
// ./app/javascript/components/core/ContainerDroppable.tsx